export const COMMON_STYLE = ['antialiased'];
